import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasPermissionPipe } from './has-permission.pipe';

@NgModule({
  declarations: [HasPermissionPipe],
  imports: [
    CommonModule
  ],
  exports: [HasPermissionPipe]
})
export class HasPermissionPipeModule { }
